export default __webpack_public_path__ + "static/media/perfil.c2a13cba.svg";